export default __webpack_public_path__ + "static/media/pantry1-afterI-480w.6b83b6be.webp";